// Derives each dashboard item's section band from the section headers in the
// layout (CONEK-6788): a widget inherits the nearest `SectionHeader:<id>` above
// it, an explicit per-item override wins, and items above the first header stay
// unsectioned. Pure client-side counterpart to GridComponent#inherited_bands so
// the editor's live repaint matches the server render.
//
// `items` must already be in visual (y, x) order. Returns a parallel array of
// { id, section } where section is the resolved band or null.
const HEADER_PREFIX = "SectionHeader:"

export function resolveSectionBands(items) {
  let current = null
  return items.map(({ id, sectionExplicit }) => {
    if (typeof id === "string" && id.startsWith(HEADER_PREFIX)) {
      current = id.slice(HEADER_PREFIX.length)
      return { id, section: current }
    }
    if (sectionExplicit) return { id, section: sectionExplicit }
    return { id, section: current }
  })
}
